/**
 * User: WangMeng
 * Date: 2018-07-17
 * Time: 15:12
 * Desc: 财务隐患提示
 */

import React, { PureComponent } from 'react';
import { Table, Modal } from 'antd';
import { PAGE_SIZE } from '../../../../constants/common';
import GroupBox from '../../../common/groupBox/GroupBox';
import { addDataIndex } from '../../../../utils/util';
import { commonRequest } from '../../common/commons';
import IndustryRecession from './danger/IndustryRecession'; // 行业整体衰退
import InternalControlAudit from './danger/InternalControlAudit'; // 内控审计
import SingleLargeShareholder from './danger/SingleLargeShareholder'; // 一股独大
import ManagementDishonest from './danger/ManagementDishonest'; // 管理层诚信不佳
import PerformanceFace from './danger/PerformanceFace'; // 业绩变脸
import ClientSupplierChange from './danger/ClientSupplierChange'; // 主要客户或供应商发生变更
import OverseasIncomeBig from './danger/OverseasIncome'; // 海外业务占比较大
import StockPledge from './danger/StockPledge'; // 股权质押数量较大
import GovernmentAllowance from './danger/GovernmentAllowance'; // 大额政府补助
import Goodwill from './danger/Goodwill'; // 商誉较大
// import ManagerDimission from '../../common/sameDetail/ManagerDimission'; // 高管异常变动 暂时不做
import AuditUnits from './danger/AuditUnits'; // 审计单位变更频繁
import GoodwillChangeAnomaly from './danger/GoodwillChangeAnomaly'; // 审计单位变更频繁
import IncomeRegionDistribution from './danger/IncomeRegionDistribution'; // 收入地区结构异常
import IncomeProduct from './danger/IncomeProduct'; // 收入产品分布异常
import QuarterMatchChange from './danger/QuarterMatchChange'; // 季度配比变化
import QuarterIncomeWave from './danger/QuarterIncomeWave'; // 季度营业收入波动异常
import AmountGuaranteed from './danger/AmountGuaranteed'; // 担保金额较大
import { tipList, tipDetail } from '../../../../services/financialPicture/riskAnalysis';

export default class Danger extends PureComponent {
    constructor(props) {
        super(props);
        // 详情ID--组件对应
        this.detailMap = {
            '34': IndustryRecession, //
            '35': InternalControlAudit, //
            '36': SingleLargeShareholder, //
            '37': ManagementDishonest, //
            '38': PerformanceFace, // 等解析数据
            '39': ClientSupplierChange, // 空数据
            '40': OverseasIncomeBig, //
            '41': StockPledge, //
            '42': GovernmentAllowance, //
            '43': Goodwill, //
            '44': AuditUnits, //
            '46': GoodwillChangeAnomaly, //
            '47': IncomeRegionDistribution, // 有空数据
            '48': IncomeProduct, // 同上 测一下
            '49': QuarterMatchChange, //
            '50': QuarterIncomeWave, //
            '51': AmountGuaranteed
        };
        this.state = {
            visible: false,
            loading: false,
            activeItem: {},
            data: []
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        this.setState({
            loading: true
        });

        tipList(commonRequest()).then(data => {
            data = data || {};
            this.setState({
                data: addDataIndex(data.list)
            });
        }).finally(() => {
            this.setState({
                loading: false
            });
        });
    };

    showModal = (d) => {
        this.setState({ visible: true, activeItem: d });
    };

    hideModal = () => {
        this.setState({ visible: false });
    };

    getColumns = () => {
        return [{
            title: '序号',
            dataIndex: 'index',
            width: 60
        }, {
            title: '经营隐患',
            dataIndex: 'exName',
            width: 260
        }, {
            title: '业务解读',
            dataIndex: 'explain'
        }, {
            title: '操作',
            dataIndex: 'operation',
            width: 80,
            render: (v, d) => this.detailMap[d.id] ? <a href="javascript:void(0)" onClick={() => this.showModal(d)}>查看详情</a> : '--'
        }];
    };

    render() {
        const { visible, data, activeItem, loading } = this.state;
        const { id } = activeItem;
        let Component = this.detailMap[id];

        return (
            <GroupBox id="risk-danger" title="财务隐患提示">
                <div className="sub-title">公司财务隐患概述</div>
                <Table
                    bordered
                    className="table-margin"
                    rowKey="id"
                    loading={loading}
                    dataSource={data}
                    columns={this.getColumns()}
                    pagination={data.length > PAGE_SIZE}
                />

                <Modal
                    width={900}
                    visible={visible}
                    onCancel={this.hideModal}
                    footer={null}
                >
                    { Component && <Component id={id} server={tipDetail}/> }
                </ Modal>
            </GroupBox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/Danger.jsx